import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {MainComponent} from './components/main/main.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HeroTextComponent} from './components/hero-text/hero-text.component';
import {MaterialModule} from './material';
import {RightMenuComponent} from './components/right-menu/right-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CountdownModule } from 'ngx-countdown';
import {
  MAT_DATE_LOCALE,
  MatDatepickerModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule,
  NativeDateModule
} from '@angular/material';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {HttpClientModule} from '@angular/common/http';
import {ReservationFormComponent} from './components/reservation-form/reservation-form.component';
import {PageHomeComponent} from './pages/Page_home/page-home.component';
import {BchooseDateComponent} from './components/bchoose-date/bchoose-date.component';
import {PageOpenSpaceComponent} from './pages/Page_open-space/page-open-space.component';
import {PageDressesComponent} from './pages/Page_dresses/page-dresses.component';
import {DressesCarouselComponent} from './components/dresses-carousel/dresses-carousel.component';
import {ArrowLeftDirective} from './directives/arrow-left/arrow-left.directive';
import {ArrowRightDirective} from './directives/arrow-right/arrow-right.directive';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import {ArrowUpDirective} from './directives/arrow-up/arrow-up.directive';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {PageScandinavianComponent} from './pages/Page_scandinavian/page-scandinavian.component';
import {PageFashionComponent} from './pages/Page_fashion/page-fashion.component';
import {PageLoftComponent} from './pages/Page_loft/page-loft.component';
import {PageBlackComponent} from './pages/Page_black/page-black.component';
import {PageWhiteSpaceComponent} from './pages/Page_white-space/page-white-space.component';
import {PageEquipmentComponent} from './pages/page-equipment/page-equipment.component';
import {PageRulesComponent} from './pages/page-rules/page-rules.component';
import {RuleBlockComponent} from './components/rule-block/rule-block.component';
import {PageContactsComponent} from './pages/page-contacts/page-contacts.component';
import {PageThankComponent} from './pages/page-thank/page-thank.component';
import {PageServicesComponent} from './pages/page-services/page-services.component';
import {HeaderMobileComponent} from './components/header-mobile/header-mobile.component';
import {PageBackstageComponent} from './pages/page-backstage/page-backstage.component';
import {PageCalendarComponent} from './pages/page-calendar/page-calendar.component';
import {CallbackModalComponent} from './components/callback-modal/callback-modal.component';
import {PagePortfolioComponent} from './pages/page-portfolio/page-portfolio.component';
import {ScrollHintComponent} from './components/scroll-hint/scroll-hint.component';
import {Resolver} from './resolver';
import {serviceResolver} from './serviceResolver';
import { PageDressingComponent } from './pages/page-dressing/page-dressing.component';
import {NgHttpLoaderModule} from 'ng-http-loader';
import { PreloaderComponent } from './preloader/preloader.component';
import { DummyComponent } from './dummy/dummy.component';


@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    MainComponent,
    HeroTextComponent,
    RightMenuComponent,
    ReservationFormComponent,
    PageHomeComponent,
    BchooseDateComponent,
    PageOpenSpaceComponent,
    PageDressesComponent,
    DressesCarouselComponent,
    ArrowLeftDirective,
    ArrowRightDirective,
    DropdownComponent,
    ArrowUpDirective,
    PageFashionComponent,
    PageScandinavianComponent,
    PageLoftComponent,
    PageBlackComponent,
    PageWhiteSpaceComponent,
    PageEquipmentComponent,
    PageRulesComponent,
    RuleBlockComponent,
    PageContactsComponent,
    PageThankComponent,
    PageServicesComponent,
    HeaderMobileComponent,
    PageBackstageComponent,
    CallbackModalComponent,
    PagePortfolioComponent,
    ScrollHintComponent,
    PageDressingComponent,
    PageCalendarComponent,
    PreloaderComponent,
    DummyComponent,
  ],
  entryComponents: [
    PageServicesComponent
  ],
  imports: [
    CountdownModule,
    BrowserModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    MaterialModule,
    NativeDateModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatMomentDateModule,
    DragDropModule,
    HttpClientModule,
    NgScrollbarModule,
    SlickCarouselModule,
    HttpClientModule,
    NgHttpLoaderModule.forRoot(),
  ],
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'ru'},
  Resolver,
  serviceResolver
],
  bootstrap: [AppComponent]
})

export class AppModule {
}
